import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "sb-teams",
  role: "tablist"
}
const _hoisted_2 = ["aria-selected"]
const _hoisted_3 = { class: "sb-team-name" }
const _hoisted_4 = { class: "sb-team-meta" }
const _hoisted_5 = { class: "bad" }
const _hoisted_6 = ["aria-selected", "onClick"]
const _hoisted_7 = { class: "sb-team-name" }
const _hoisted_8 = { class: "sb-team-meta" }
const _hoisted_9 = { class: "bad" }
const _hoisted_10 = {
  key: 1,
  class: "rk-bar"
}
const _hoisted_11 = {
  key: 0,
  class: "rk-seg"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  key: 1,
  class: "sb-search"
}
const _hoisted_14 = {
  key: 0,
  class: "sb-search-count"
}
const _hoisted_15 = {
  key: 2,
  class: "rk-sum"
}
const _hoisted_16 = { class: "rk-sum-main" }
const _hoisted_17 = { class: "rk-sum-k" }
const _hoisted_18 = { class: "rk-sum-v" }
const _hoisted_19 = { class: "rk-qbar" }
const _hoisted_20 = { class: "rk-stat ok" }
const _hoisted_21 = { class: "rk-stat bad" }
const _hoisted_22 = { class: "rk-stat" }
const _hoisted_23 = { class: "rk-sum-msg" }
const _hoisted_24 = { class: "bad" }
const _hoisted_25 = { class: "rk-sum-main" }
const _hoisted_26 = { class: "rk-sum-k" }
const _hoisted_27 = { class: "rk-sum-v" }
const _hoisted_28 = { class: "rk-sum-main" }
const _hoisted_29 = { class: "rk-sum-k" }
const _hoisted_30 = { class: "rk-sum-v" }
const _hoisted_31 = { class: "rk-sum-msg" }
const _hoisted_32 = {
  key: 0,
  class: "rk-rocks"
}
const _hoisted_33 = { class: "rk-group-h" }
const _hoisted_34 = ["aria-label", "onClick", "onKeydown"]
const _hoisted_35 = { class: "rk-rtop" }
const _hoisted_36 = ["title"]
const _hoisted_37 = { class: "rk-rhead" }
const _hoisted_38 = { class: "rk-rname" }
const _hoisted_39 = { class: "rk-meta" }
const _hoisted_40 = ["title"]
const _hoisted_41 = {
  key: 0,
  class: "rk-chip"
}
const _hoisted_42 = {
  key: 1,
  class: "rk-chip"
}
const _hoisted_43 = ["title"]
const _hoisted_44 = ["onClick"]
const _hoisted_45 = {
  key: 0,
  class: "rk-done"
}
const _hoisted_46 = {
  key: 1,
  class: "rk-ms"
}
const _hoisted_47 = { class: "rk-dots" }
const _hoisted_48 = ["title"]
const _hoisted_49 = { class: "rk-foot" }
const _hoisted_50 = ["href", "title"]
const _hoisted_51 = ["onClick"]
const _hoisted_52 = {
  key: 1,
  class: "rk-empty"
}
const _hoisted_53 = { key: 0 }
const _hoisted_54 = { key: 1 }
const _hoisted_55 = { key: 2 }
const _hoisted_56 = { key: 3 }
const _hoisted_57 = { key: 4 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_rock_modal = _resolveComponent("rock-modal")!
  const _component_forge_team = _resolveComponent("forge-team")!
  const _component_quick_add_agenda_item = _resolveComponent("quick-add-agenda-item")!
  const _component_rock_week_modal = _resolveComponent("rock-week-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.loaded && !_ctx.noTeam && !_ctx.team)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.myEmployeeID)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                role: "tab",
                "aria-selected": !_ctx.searching && _ctx.showMine,
                class: _normalizeClass(["sb-team", !_ctx.searching && _ctx.showMine ? 'on' : '']),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectMine()))
              }, [
                _createElementVNode("span", _hoisted_3, [
                  _createVNode(_component_svg_icon, {
                    icon: "user",
                    class: "sb-team-ic"
                  }),
                  _cache[16] || (_cache[16] = _createTextVNode("My rocks", -1))
                ]),
                _createElementVNode("span", _hoisted_4, [
                  _createTextVNode(_toDisplayString(_ctx.myRocks.length) + " across " + _toDisplayString(_ctx.myTeamCount) + " team" + _toDisplayString(_ctx.myTeamCount == 1 ? '' : 's'), 1),
                  (_ctx.tabStats(_ctx.myRocks).off)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _cache[17] || (_cache[17] = _createTextVNode(" · ", -1)),
                        _createElementVNode("b", _hoisted_5, _toDisplayString(_ctx.tabStats(_ctx.myRocks).off) + " off track", 1)
                      ], 64))
                    : _createCommentVNode("", true)
                ])
              ], 10, _hoisted_2))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teams, (t) => {
            return (_openBlock(), _createElementBlock("button", {
              key: t,
              type: "button",
              role: "tab",
              "aria-selected": !_ctx.searching && !_ctx.showMine && t == _ctx.activeTeam,
              class: _normalizeClass(["sb-team", !_ctx.searching && !_ctx.showMine && t == _ctx.activeTeam ? 'on' : '']),
              onClick: ($event: any) => (_ctx.selectTeam(t))
            }, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.teamLabel(t)), 1),
              _createElementVNode("span", _hoisted_8, [
                _createTextVNode(_toDisplayString(_ctx.teamRocks(t).length) + " rock" + _toDisplayString(_ctx.teamRocks(t).length == 1 ? '' : 's'), 1),
                (_ctx.tabStats(_ctx.teamRocks(t)).off)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _cache[18] || (_cache[18] = _createTextVNode(" · ", -1)),
                      _createElementVNode("b", _hoisted_9, _toDisplayString(_ctx.tabStats(_ctx.teamRocks(t)).off) + " off track", 1)
                    ], 64))
                  : _createCommentVNode("", true)
              ])
            ], 10, _hoisted_6))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (!_ctx.noTeam)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          (!_ctx.team)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.quarters, (q) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: q,
                    type: "button",
                    class: _normalizeClass(q == _ctx.quarter ? 'on' : ''),
                    onClick: ($event: any) => (_ctx.selectQuarter(q))
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.quarterLabel(q)), 1),
                    (q == _ctx.current)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(" · now")
                        ], 64))
                      : (q == _ctx.nextQ)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(" · next")
                          ], 64))
                        : _createCommentVNode("", true)
                  ], 10, _hoisted_12))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (!_ctx.team)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _cache[20] || (_cache[20] = _createElementVNode("svg", {
                  viewBox: "0 0 24 24",
                  "aria-hidden": "true"
                }, [
                  _createElementVNode("circle", {
                    cx: "11",
                    cy: "11",
                    r: "7"
                  }),
                  _createElementVNode("path", { d: "M21 21l-4.35-4.35" })
                ], -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.search) = $event)),
                  type: "text",
                  placeholder: "Search all rocks",
                  "aria-label": "Search all rocks",
                  onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.search = ''), ["esc"]))
                }, null, 544), [
                  [_vModelText, _ctx.search]
                ]),
                (_ctx.searching)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.visibleRocks.length) + " found", 1))
                  : _createCommentVNode("", true),
                (_ctx.search)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      type: "button",
                      class: "sb-search-clear",
                      title: "Clear search",
                      "aria-label": "Clear search",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.search = ''))
                    }, [...(_cache[19] || (_cache[19] = [
                      _createElementVNode("svg", {
                        viewBox: "0 0 24 24",
                        "aria-hidden": "true"
                      }, [
                        _createElementVNode("path", { d: "M18 6L6 18M6 6l12 12" })
                      ], -1)
                    ]))]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _cache[22] || (_cache[22] = _createElementVNode("span", { style: {"flex":"1"} }, null, -1)),
          (_ctx.canAdd && !_ctx.team)
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: "ai-btn rk-btn rk-forge",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showForge = true))
              }, [...(_cache[21] || (_cache[21] = [
                _createElementVNode("svg", {
                  "aria-hidden": "true",
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "15",
                  height: "15",
                  viewBox: "0 0 24 24",
                  fill: "currentColor",
                  "fill-rule": "evenodd"
                }, [
                  _createElementVNode("path", { d: "M12 23c-4.4 0-8-3.1-8-7.5 0-3.3 2-5.6 3.6-7.4.4-.4 1.1-.1 1.1.5 0 1.3.6 2.6 1.6 3.2C10.1 7.7 11.6 4 15 1.2c.4-.3 1 0 1 .5-.1 2.6.9 4.5 2.2 6.4C19.3 9.8 20 11.6 20 15.5 20 19.9 16.4 23 12 23zm0-2c1.9 0 3.3-1.3 3.3-3.1 0-1.6-.9-2.7-2.1-3.9-.3-.3-.8-.1-.8.3-.1 1-.6 1.8-1.3 2.2-.1-1.1-.5-2-1.1-2.6-.3-.3-.8-.1-.8.3-.3 1.3-1.5 2.2-1.5 3.7C7.7 19.7 9.8 21 12 21z" })
                ], -1),
                _createTextVNode("Improve with AI", -1)
              ]))]))
            : _createCommentVNode("", true),
          ((_ctx.quarter == _ctx.current || _ctx.quarter == _ctx.nextQ) && _ctx.myEmployeeID && !_ctx.team)
            ? (_openBlock(), _createElementBlock("div", {
                key: 3,
                class: "btn-light rk-btn",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showRockWeek = true))
              }, "Plan " + _toDisplayString(_ctx.quarterLabel(_ctx.nextQ)), 1))
            : _createCommentVNode("", true),
          (_ctx.canAdd)
            ? (_openBlock(), _createElementBlock("div", {
                key: 4,
                class: "btn rk-btn",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.openRock(null)))
              }, "Add Rock"))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.loaded && !_ctx.noTeam && (!_ctx.team || _ctx.activeTeam))
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          (_ctx.quarter == _ctx.current)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.tabLabel) + " · " + _toDisplayString(_ctx.quarterLabel(_ctx.quarter)) + " · week " + _toDisplayString(_ctx.weekNow) + " of 13", 1),
                  _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.daysLeft(_ctx.quarter)) + " days left · ends " + _toDisplayString(_ctx.shortDate(_ctx.bounds.end)), 1),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("span", {
                      style: _normalizeStyle('width:' + Math.round(_ctx.weekNow / 13 * 100) + '%')
                    }, null, 4)
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("b", null, _toDisplayString(_ctx.countStatus('on')), 1),
                  _cache[23] || (_cache[23] = _createElementVNode("span", null, "on track", -1))
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("b", null, _toDisplayString(_ctx.countStatus('off')), 1),
                  _cache[24] || (_cache[24] = _createElementVNode("span", null, "off track", -1))
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("b", null, _toDisplayString(_ctx.countStatus('done')), 1),
                  _cache[25] || (_cache[25] = _createElementVNode("span", null, "done", -1))
                ]),
                _createElementVNode("div", _hoisted_23, [
                  (_ctx.lateRocks.length)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.lateRocks.length) + " rock" + _toDisplayString(_ctx.lateRocks.length > 1 ? 's have' : ' has') + " a missed milestone:", 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.lateRocks.slice(0, 2).map(r => r.Name).join(', ')) + _toDisplayString(_ctx.lateRocks.length > 2 ? '…' : ''), 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode("No missed milestones. Owners say on or off track every week.")
                      ], 64))
                ])
              ], 64))
            : (_ctx.quarter > _ctx.current)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.tabLabel) + " · " + _toDisplayString(_ctx.quarterLabel(_ctx.quarter)) + " · planned", 1),
                    _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.visibleRocks.length) + " rock" + _toDisplayString(_ctx.visibleRocks.length == 1 ? '' : 's') + " set · starts " + _toDisplayString(_ctx.shortDate(_ctx.bounds.start)), 1)
                  ]),
                  _cache[26] || (_cache[26] = _createElementVNode("div", { class: "rk-sum-msg" }, "3 to 7 rocks per team. Every rock gets one owner and milestones.", -1))
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.tabLabel) + " · " + _toDisplayString(_ctx.quarterLabel(_ctx.quarter)) + " · complete", 1),
                    _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.countStatus('done')) + " of " + _toDisplayString(_ctx.visibleRocks.length) + " rocks done · " + _toDisplayString(_ctx.pastPct) + "%", 1),
                    _createElementVNode("div", {
                      class: _normalizeClass(["rk-qbar", _ctx.pastPct >= 80 ? 'ok' : ''])
                    }, [
                      _createElementVNode("span", {
                        style: _normalizeStyle('width:' + _ctx.pastPct + '%')
                      }, null, 4)
                    ], 2)
                  ]),
                  _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.pastPct >= 80 ? 'Hit the 80% EOS target.' : 'EOS aims for 80% or better.'), 1)
                ], 64))
        ]))
      : _createCommentVNode("", true),
    (_ctx.loaded)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
          (_ctx.rockGroups.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rockGroups, (g) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: g.key
                  }, [
                    _createElementVNode("div", _hoisted_33, [
                      _createTextVNode(_toDisplayString(g.label), 1),
                      _createElementVNode("span", null, _toDisplayString(g.rocks.length), 1)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(g.rocks, (r) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: r.ID,
                        class: _normalizeClass(["rk-rock", r.Status]),
                        role: "button",
                        tabindex: "0",
                        "aria-label": r.Name,
                        onClick: ($event: any) => (_ctx.openRock(r)),
                        onKeydown: _withKeys(_withModifiers(($event: any) => (_ctx.openRock(r)), ["self"]), ["enter"])
                      }, [
                        _createElementVNode("div", _hoisted_35, [
                          _createElementVNode("span", {
                            class: "rk-own",
                            title: _ctx.ownerNames(r)
                          }, _toDisplayString(_ctx.initials(_ctx.ownerName(r.OwnerEmployeeID))), 9, _hoisted_36),
                          _createElementVNode("div", _hoisted_37, [
                            _createElementVNode("div", _hoisted_38, _toDisplayString(r.Name), 1),
                            _createElementVNode("div", _hoisted_39, [
                              _createElementVNode("span", {
                                title: _ctx.ownerNames(r)
                              }, [
                                _createTextVNode(_toDisplayString(_ctx.ownerName(r.OwnerEmployeeID)), 1),
                                ((r.AdditionalOwnerIDs || []).length)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode(", " + _toDisplayString(r.AdditionalOwnerIDs.map(_ctx.firstName).join(', ')), 1)
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ], 8, _hoisted_40),
                              (_ctx.byTeam && r.TeamRock)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_41, "Team Rock"))
                                : _createCommentVNode("", true),
                              (r.CarriedFromRockID)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_42, "From " + _toDisplayString(_ctx.quarterLabel(_ctx.prevQuarter(r.Quarter))), 1))
                                : _createCommentVNode("", true),
                              (_ctx.otherTeams(r).length)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 2,
                                    class: "rk-chip",
                                    title: 'Also on ' + _ctx.otherTeams(r).map(_ctx.teamLabel).join(', ')
                                  }, "Also on " + _toDisplayString(_ctx.otherTeams(r).map(_ctx.teamLabel).join(', ')), 9, _hoisted_43))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          (_ctx.canChange(r) && _ctx.live && (r.Status == 'on' || r.Status == 'off'))
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                class: _normalizeClass(["rk-st", _ctx.statusInfo(r).cls]),
                                title: "Click to switch on/off track",
                                onClick: _withModifiers(($event: any) => (_ctx.toggleStatus(r)), ["stop"])
                              }, _toDisplayString(_ctx.statusInfo(r).label) + " ⇄", 11, _hoisted_44))
                            : (_openBlock(), _createElementBlock("span", {
                                key: 1,
                                class: _normalizeClass(["rk-st", _ctx.statusInfo(r).cls])
                              }, _toDisplayString(_ctx.statusInfo(r).label), 3))
                        ]),
                        (r.DoneStatement)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                              _cache[27] || (_cache[27] = _createElementVNode("b", null, "Done:", -1)),
                              _createTextVNode(" " + _toDisplayString(r.DoneStatement), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (r.Milestones.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                              _createElementVNode("div", _hoisted_47, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(r.Milestones, (m) => {
                                  return (_openBlock(), _createElementBlock("span", {
                                    key: m.ID,
                                    class: _normalizeClass(["rk-dot", m.Done ? 'd' : (m.DueDate < _ctx.todayDate ? 'late' : '')]),
                                    title: m.Text + ' · ' + _ctx.shortDate(m.DueDate) + ' · ' + _ctx.ownerName(m.OwnerEmployeeID || r.OwnerEmployeeID) + (m.Done ? ' · done' : '')
                                  }, null, 10, _hoisted_48))
                                }), 128))
                              ]),
                              _createElementVNode("span", null, _toDisplayString(r.Milestones.filter(m => m.Done).length) + "/" + _toDisplayString(r.Milestones.length) + " milestones", 1)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_49, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["rk-next", _ctx.nextLine(r).cls])
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.nextLine(r).text) + " ", 1),
                            (_ctx.nextLine(r).link)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  class: "rk-next-link",
                                  href: _ctx.nextLine(r).link,
                                  target: "_blank",
                                  rel: "noopener",
                                  title: _ctx.nextLine(r).link,
                                  onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
                                }, [
                                  _createVNode(_component_svg_icon, { icon: "link" }),
                                  _createElementVNode("span", null, _toDisplayString(_ctx.linkLabel(_ctx.nextLine(r).link)), 1)
                                ], 8, _hoisted_50))
                              : _createCommentVNode("", true)
                          ], 2),
                          _createElementVNode("button", {
                            type: "button",
                            class: "rk-issue",
                            onClick: _withModifiers(($event: any) => (_ctx.openIssue(r)), ["stop"])
                          }, "Issue", 8, _hoisted_51)
                        ])
                      ], 42, _hoisted_34))
                    }), 128))
                  ], 64))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_52, [
                _createVNode(_component_svg_icon, { icon: "star" }),
                (_ctx.searching)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_53, "No rocks for " + _toDisplayString(_ctx.quarterLabel(_ctx.quarter)) + " match \"" + _toDisplayString(_ctx.search.trim()) + "\".", 1))
                  : (_ctx.showMine)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_54, "You don't own any rocks for " + _toDisplayString(_ctx.quarterLabel(_ctx.quarter)) + ". Rocks you're the owner of, on any team, show up here.", 1))
                    : (_ctx.team && !_ctx.activeTeam)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_55, "You can't open the " + _toDisplayString(_ctx.teamLabel(_ctx.team)) + " rocks. Only people on the team and Team Hub admins can.", 1))
                      : (_ctx.activeTeam)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_56, _toDisplayString(_ctx.teamLabel(_ctx.activeTeam)) + " doesn't have any rocks for " + _toDisplayString(_ctx.quarterLabel(_ctx.quarter)) + " yet.", 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_57, "You don't belong to a team yet. Contact your administrator to be added to a team.")),
                (_ctx.searching)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 5,
                      class: "btn-light rk-btn",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.search = ''))
                    }, "Clear Search"))
                  : (_ctx.canAdd)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 6,
                        class: "btn rk-btn",
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.openRock(null)))
                      }, "Add the First Rock"))
                    : _createCommentVNode("", true)
              ]))
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.showRock)
      ? (_openBlock(), _createBlock(_component_rock_modal, {
          key: 4,
          rock: _ctx.rockToEdit,
          quarter: _ctx.quarter,
          "default-team": _ctx.newRockTeam,
          employees: _ctx.employees,
          teams: _ctx.teams,
          myEmployeeID: _ctx.myEmployeeID,
          onClose: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showRock = false)),
          onSaved: _ctx.onRockSaved
        }, null, 8, ["rock", "quarter", "default-team", "employees", "teams", "myEmployeeID", "onSaved"]))
      : _createCommentVNode("", true),
    (_ctx.showForge)
      ? (_openBlock(), _createBlock(_component_forge_team, {
          key: 5,
          modal: "",
          only: [ 'improve', 'milestones', 'rocks' ],
          "start-kind": "improve",
          "preset-team": _ctx.newRockTeam || '',
          "preset-quarter": _ctx.quarter,
          onApplied: _cache[11] || (_cache[11] = ($event: any) => (_ctx.load())),
          onClose: _cache[12] || (_cache[12] = ($event: any) => (_ctx.showForge = false))
        }, null, 8, ["preset-team", "preset-quarter"]))
      : _createCommentVNode("", true),
    (_ctx.issue)
      ? (_openBlock(), _createBlock(_component_quick_add_agenda_item, {
          key: 6,
          heading: "Add Issue",
          "prefer-column": "Issues",
          preset: _ctx.issue.preset,
          team: _ctx.issue.team,
          "fixed-meeting": _ctx.meeting,
          onClose: _cache[13] || (_cache[13] = ($event: any) => (_ctx.issue = null))
        }, null, 8, ["preset", "team", "fixed-meeting"]))
      : _createCommentVNode("", true),
    (_ctx.showRockWeek)
      ? (_openBlock(), _createBlock(_component_rock_week_modal, {
          key: 7,
          quarter: _ctx.current,
          employees: _ctx.employees,
          teams: _ctx.teams,
          "default-team": _ctx.newRockTeam,
          myEmployeeID: _ctx.myEmployeeID,
          onClose: _cache[14] || (_cache[14] = ($event: any) => (_ctx.closeRockWeek())),
          onChanged: _cache[15] || (_cache[15] = ($event: any) => (_ctx.load())),
          onFinish: _ctx.finishRockWeek
        }, null, 8, ["quarter", "employees", "teams", "default-team", "myEmployeeID", "onFinish"]))
      : _createCommentVNode("", true)
  ]))
}